<template>
  <div class="header-title">
      <h1 class="mt-3" v-if="title">{{ $t(title) }}</h1>
      <h1 class="mt-3" v-else> {{ $t($route.name) }} </h1>
  </div>
</template>

<script>

import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      show: "panel/sidebarShow",
      minimize: "panel/sidebarMinimize"
    })
  },
  props:{
    title: String
  }
};
</script>
<style scoped lang="scss">
  .header-title{
        background: transparent;
        /* border-color: #c8ced3; */
        background-clip: border-box;
        border: 1px solid #f0f2f4bf;
        word-wrap: break-word;
        margin-top: 5px;
        margin-bottom: 5px;
        padding: 0px;
        color: #000000b3;
        text-align: center;
        font-size: 19px;
        line-height: 35px;
        box-shadow: 1px 1px 1px #cccecf;
  }
  .c-dark-theme{
      & .header-title{
          color: white;
          border-color: transparent;
          box-shadow: none;
      }
  }
  
</style>
